import * as tslib_1 from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Subheading } from 'sinoui-components/Text';
var DayBox = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  padding: 4px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n  background: ", ";\n  border: ", ";\n  border: ", ";\n  box-shadow: ", ";\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n  }\n"], ["\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  padding: 4px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ",
    ";\n  background: ",
    ";\n  border: ",
    ";\n  border: ",
    ";\n  box-shadow: ",
    ";\n  &:hover {\n    cursor: pointer;\n    background: ",
    ";\n  }\n"])), function (props) {
    return props.checked ? props.theme.palette.primary[500] : null;
}, function (props) {
    return props.enable ? props.theme.palette.background.divider : null;
}, function (props) {
    return props.today && !props.enable
        ? '1px solid ' + props.theme.palette.text.secondary
        : null;
}, function (props) {
    return props.today && props.checked
        ? '1px solid ' + props.theme.palette.primary[500]
        : null;
}, function (props) {
    return props.today
        ? 'inset 0 0 0 1px ' + props.theme.palette.background.paper
        : null;
}, function (props) {
    return !props.checked && props.dayNum
        ? props.theme.palette.background.appBar
        : null;
});
var TitleBox = styled(Subheading)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ",
    ";\n"])), function (props) {
    return props.checked
        ? props.theme.palette.text.snackbar
        : props.theme.palette.text.secondary;
});
export default function CalendarDayItem(props) {
    return (React.createElement(DayBox, { checked: props.checked, today: props.today, enable: props.enable, dayNum: props.dayNum, onClick: function (e) { return props.selectDay(props.dayNum, e); } },
        React.createElement(TitleBox, { checked: props.checked }, props.dayNum)));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=CalendarDayItem.js.map